module.exports = __webpack_public_path__ + "img/header-engagementRingsFancy.da7f952.jpg";